module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-20.cd43452.woff2";